module.exports = __webpack_public_path__ + "media/images/support/geolocation/geolocation-firefox-permission-1-3323c0415ee3fc8a7ba309c68db5ca2b.png";